import React, { useState, useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type BonusItem = {
  title: string;
  description: string;
  icon: React.ReactNode;
  previewImage: string;
  previewAlt: string;
};
type BonusCarouselProps = {
  bonuses: BonusItem[];
};
export function BonusCarousel({
  bonuses
}: BonusCarouselProps) {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    const nextIndex = Math.max(0, Math.min(index, bonuses.length - 1));
    const slide = carouselRef.current?.children[nextIndex] as HTMLElement | undefined;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slide?.scrollIntoView({
      behavior: reducedMotion ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'start'
    });
    setActiveIndex(nextIndex);
  };
  const updateActiveSlide = () => {
    const track = carouselRef.current;
    if (!track) return;
    const trackCenter = track.scrollLeft + track.clientWidth / 2;
    const nearestIndex = Array.from(track.children).reduce((closestIndex, slide, index) => {
      const closest = track.children[closestIndex] as HTMLElement;
      const current = slide as HTMLElement;
      const closestDistance = Math.abs(closest.offsetLeft + closest.offsetWidth / 2 - trackCenter);
      const currentDistance = Math.abs(current.offsetLeft + current.offsetWidth / 2 - trackCenter);
      return currentDistance < closestDistance ? index : closestIndex;
    }, 0);
    setActiveIndex(nearestIndex);
  };
  return <section className="bonus-carousel" aria-roledescription="carrusel" aria-label="Bonos incluidos" data-id="element-11" data-mp="3p57w1qgriry4">
      <div className="bonus-carousel-track" ref={carouselRef} onScroll={updateActiveSlide} tabIndex={0} aria-label="Desliza para ver los bonos incluidos" data-id="element-12" data-mp="3ka2a4rnd1da1">
        {bonuses.map((bonus, index) => <article className="bonus-slide" key={bonus.title} aria-label={`${bonus.title}. Bono ${index + 1} de ${bonuses.length}`} data-id="element-13" data-mp="10u58lply4501" data-mpi={index}>
            <div className="bonus-slide-image" data-id="element-14" data-mp="qvfnlnyr64fk">
              <img src={bonus.previewImage} alt={bonus.previewAlt} data-id="element-15" data-mp="quo4vdq9816p" />
              <span className="bonus-slide-count" data-id="element-16" data-mp="vsy0tqjsz5td">Bono {index + 1}</span>
            </div>
            <div className="bonus-slide-content" data-id="element-17" data-mp="h4urq8agre0c">
              <span className="bonus-slide-icon" aria-hidden="true" data-id="element-18" data-mp="h308cyeubtyd">
                {bonus.icon}
              </span>
              <h3 data-id="element-19" data-mp="84etpechoz2v">{bonus.title}</h3>
              <p data-id="element-20" data-mp="85hi9fmcapfm">{bonus.description}</p>
            </div>
          </article>)}
      </div>

      <div className="bonus-carousel-controls" data-id="element-21" data-mp="d4knp168exo4">
        <button type="button" className="carousel-control" onClick={() => goToSlide(activeIndex - 1)} disabled={activeIndex === 0} aria-label="Ver bono anterior" data-id="element-22" data-mp="d1571twwtgkl">
          <ChevronLeftIcon size={19} aria-hidden="true" data-id="element-23" data-mp="3foo1s51vfhc9" />
        </button>
        <p className="bonus-carousel-status" aria-live="polite" data-id="element-24" data-mp="3fqr33l8h4wwa">
          {activeIndex + 1} de {bonuses.length}
        </p>
        <button type="button" className="carousel-control" onClick={() => goToSlide(activeIndex + 1)} disabled={activeIndex === bonuses.length - 1} aria-label="Ver siguiente bono" data-id="element-25" data-mp="3pmu60tb5gzka">
          <ChevronRightIcon size={19} aria-hidden="true" data-id="element-26" data-mp="2h32i1uml4fm" />
        </button>
      </div>
      <p className="bonus-swipe-hint" data-id="element-27" data-mp="3ul5fh2xj981z">Desliza para ver los bonos</p>
    </section>;
}